import React from 'react';

import { ColumnOption } from '../../Table/Table';

export const getSortIndicator = ({
  column,
  isColumnSorted,
  isDesc,
}: {
  column: ColumnOption;
  isColumnSorted: boolean;
  isDesc: boolean;
}) => {
  if (!column.sorting || !isColumnSorted) {
    return null;
  }

  return <i className="material-icons iconAscDesc">{isDesc ? 'arrow_downward' : 'arrow_upward'}</i>;
};
